<template>
  <v-row>
    <v-col class="col-12 d-flex justify-space-between">
      <h2>Family Tree</h2>
      <v-btn v-if="!tree.length" @click="dialog = true" color="primary">
        <v-icon left>mdi-plus</v-icon>
        New Family Tree
      </v-btn>
    </v-col>
    <v-col class="col-12" justify="center">
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>New Family Tree</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="saveNewFamilyTree()"> Save </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-row class="mx-0 mt-4">
            <v-col class="col-12">
              <v-card>
                <v-card-title> Family Name </v-card-title>
                <v-card-text class="pb-0">
                  <v-text-field
                    outlined
                    dense
                    label="Family Name"
                    v-model="familyName"
                  ></v-text-field>
                </v-card-text>
                <v-row class="no-gutters">
                  <v-col class="col-12 col-md-6 py-0">
                    <v-card-text class="pb-0">
                      <v-text-field
                        label="The oldest ancestor name"
                        outlined
                        dense
                        v-model="treeObj.firstPerson"
                      ></v-text-field>
                    </v-card-text>
                  </v-col>
                  <v-col class="col-12 col-md-6 py-0">
                    <v-card-text class="pb-0">
                      <v-text-field
                        label="Name of his partner"
                        outlined
                        dense
                        v-model="treeObj.secondPerson"
                      ></v-text-field>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col class="col-12">
              <v-card>
                <v-card-title class="d-block">
                  <div class="d-flex justify-space-between">
                    <span>Children</span>
                    <v-btn
                      small
                      dark
                      color="indigo"
                      @click="addChildrenRows()"
                      elevation="0"
                    >
                      <v-icon dark left> mdi-plus </v-icon>
                      Add descendant
                    </v-btn>
                  </div>
                </v-card-title>
                <v-card-text>
                  <v-row
                    v-for="(childrenRow, index) in childrenRows"
                    :key="index"
                  >
                    <v-col class="col-12 col-md-5 pb-0">
                      <v-text-field
                        label="Name *"
                        v-model="childrenRow.firstPerson.name"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col class="col-12 col-md-5 pb-0">
                      <v-text-field
                        label="Partner name"
                        v-model="childrenRow.secondPerson.name"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col class="col-12 col-md-2 pb-0 text-right">
                      <v-btn
                        text
                        color="error"
                        elevation="0"
                        @click="removeChildrenRows(index)"
                      >
                        Remove
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col class="col-12" v-if="tree.length">
      <VueFamilyTree :tree="tree" @card-click="cardClick" />
    </v-col>
  </v-row>
</template>

<script>
import VueFamilyTree from "vue-family-tree";
export default {
  name: "FamilyTree",
  components: {
    VueFamilyTree,
  },
  data() {
    return {
      childrenRows: [
        {
          firstPerson: {
            name: "",
          },
          secondPerson: {
            name: "",
          },
        },
      ],
      dialog: false,
      familyName: "",
      treeObj: {
        firstPerson: "",
        secondPerson: "",
      },
      tree: [],
      treeCopy: [
        {
          firstPerson: {
            name: "John Walker",
            image: "https://picsum.photos/300/300?random=1",
          },
          secondPerson: {
            name: "Jannet Grem",
            image: "https://picsum.photos/300/300?random=2",
          },
          children: [
            {
              firstPerson: {
                name: "Katia",
                image: "https://picsum.photos/300/300?random=2",
                age: 24,
              },
              secondPerson: {
                name: "Oleg",
              },
              children: [
                {
                  firstPerson: {
                    name: "Gleb",
                  },
                  secondPerson: {
                    name: "Viktoriya",
                  },
                  children: [
                    {
                      firstPerson: {
                        name: "Rim",
                      },
                      secondPerson: {
                        name: "Natasha",
                      },
                    },
                    {
                      firstPerson: {
                        name: "Leonid",
                      },
                    },
                  ],
                },
                {
                  firstPerson: {
                    name: "Olga",
                  },
                  secondPerson: {
                    name: "Nikita",
                  },
                },
              ],
            },
            {
              firstPerson: {
                name: "Vitia",
              },
              secondPerson: {
                name: "Dasha",
              },
            },
            {
              firstPerson: {
                name: "Antonio Wild",
                image: "https://picsum.photos/300/300?random=3",
              },
              secondPerson: {
                name: "Olivia Olson",
              },
              children: [
                {
                  firstPerson: {
                    name: "Kristina Wild",
                  },
                },
                {
                  firstPerson: {
                    name: "Alexey Wild",
                  },
                },
                {
                  firstPerson: {
                    name: "Viktor Wild",
                  },
                  secondPerson: {
                    name: "Veljkoooo",
                  },
                  children: [
                    {
                      firstPerson: {
                        name: "Luka Wild",
                      },
                    },
                    {
                      firstPerson: {
                        name: "Teo Wild",
                      },
                    },
                    {
                      firstPerson: {
                        name: "Luna Wild",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    };
  },
  mounted() {
    document.title = "Good Casper - Family Tree";
  },
  methods: {
    cardClick(item) {
      this.dialog = true;
    },
    saveNewFamilyTree() {
      var filteredChildrens = this.childrenRows.map((el) => {
        if (!el.secondPerson.name) {
          return {
            firstPerson: {
              name: el.firstPerson.name,
            },
          };
        } else {
          return el;
        }
      });

      this.tree.push({
        firstPerson: {
          name: this.treeObj.firstPerson + " " + this.familyName,
        },
        secondPerson: {
          name: this.treeObj.secondPerson + " " + this.familyName,
        },
        children: [...filteredChildrens],
      });
      this.dialog = false;
    },
    removeChildrenRows(currentIndex) {
      this.childrenRows = this.childrenRows.filter((el, index) => {
        return index != currentIndex;
      });
    },
    addChildrenRows() {
      this.childrenRows.push({
        firstPerson: {
          name: "",
        },
        secondPerson: {
          name: "",
        },
      });
    },
  },
};
</script>

<style lang="scss">
.v-input--radio-group--row .v-input--radio-group__input {
  justify-content: center;
}
</style>